<script setup>
import { computed, defineAsyncComponent } from 'vue'

const HeartContainer = defineAsyncComponent(
  () => import('@/components/basic/atoms/HeartContainer.vue')
)
const BackgroundImage = defineAsyncComponent(
  () => import('@/components/pdp/atoms/BackgroundImage.vue')
)
const TheMenu = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheMenu.vue')
)

const props = defineProps({
  title: String,
  imgSrc: String,
  score: Number,
  details: String,
  createdAt: String,
  disabled: {
    type: Boolean,
    default: false
  },
  includeProps: {
    type: Boolean,
    default: false
  }
})

const initials = computed(() => {
  return props.title.length > 0 ? props.title[0].toUpperCase() : ''
})

const isoCreatedAt = computed(() => {
  return new Date(props.createdAt.split('.').reverse().join('/')).toISOString()
})
</script>

<template>
  <TheMenu :title="title">
    <template v-slot:activator="{ props }">
      <div class="d-flex">
        <button
          type="button"
          v-bind="disabled ? null : props"
          class="image-wrapper"
        >
          <BackgroundImage v-if="imgSrc" :image="imgSrc" class="review-image" />
          <span v-else class="initials">{{ initials }}</span>
        </button>
        <div
          itemscope
          itemtype="https://schema.org/Person"
          itemprop="author"
          class="d-flex flex-column ml-3 align-start"
        >
          <div class="d-flex font-size-s text-uppercase">
            <button
              type="button"
              v-bind="disabled ? null : props"
              class="font-weight-bold font-garbata"
              :class="disabled ? 'c-gray' : 'link-winered'"
              itemprop="name"
            >
              {{ title }}
            </button>
            <span
              v-if="createdAt"
              class="c-black"
              itemprop="datePublished"
              :content="isoCreatedAt"
            >
              , {{ createdAt }}
            </span>
          </div>
          <slot name="sub">
            <HeartContainer
              v-if="score"
              class="mt-1"
              :rating="score"
              :include-props="includeProps"
            />
          </slot>
        </div>
      </div>
    </template>
    <slot name="details" />
  </TheMenu>
</template>

<style scoped>
.image-wrapper .initials {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgb(var(--v-theme-beige));
  overflow: hidden;
  font-weight: 700;
  font-size: var(--xxxl-font-size);
  color: rgb(var(--v-theme-white));
  line-height: 50px;
  text-align: center;
}

.review-image {
  height: 50px;
  width: 50px;
  margin: auto;
  background-size: cover;
  background-position: 50%;
  border-radius: 50%;
}
</style>
